import { match as organization } from "../../../src/params/organization.ts";
import { match as perms } from "../../../src/params/perms.ts";

export const matchers = { organization, perms };